var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":false,"large":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Sérúrræði nemanda")]),_c('br'),_c('StudentSpecialResource',{attrs:{"id":_vm.id,"showInfo":_vm.showInfo},on:{"reload":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }